import * as React from 'react';

function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 15 16" fill="none" {...props}>
			<path
				d="M14.831 14.516l-3.607-3.607a6.348 6.348 0 10-.815.815l3.607 3.607a.577.577 0 00.815-.815zM1.17 6.856a5.187 5.187 0 1110.373 0 5.187 5.187 0 01-10.373 0z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default SearchIcon;
